/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './styles.css';

import { Button, Toggler } from '@components';
import { Field, Formik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { HOME } from '../../common/utils/paths';
import {
  alterarPersonalizacaoRequest,
  recuperaPersonalizacaoRequest,
} from '../../store/modules/personalizacaoHome/actions';

export const PersonalizacaoHomePage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const personalizaHome = useSelector((state) => state.customizaHome);
  const user = useSelector((state) => state.user);
  const {
    tabela_contribuicao: showTabelaContribuicao,
    simular_beneficio: showBeneficio,
    // contracheque: showContracheque, // desativado card de contracheque 23/12/2024
    alterar_perfil: showAlterarPerfil,
    grafico_rendimento: showSaldo,
    transformacao_reserva: showTransformacaoReserva,
    saque_vista: showSaqueVista,
    reserva_matematica: showReservaMatematica,
    alterar_recebimento: showAlterarRecebimento,
    parcela_adicional: showParcelaAdicional,
    memoria_calculo: showMemoriaCalculo,
    informe_rendimento: showInforme,
    simular_conversao_beneficio: showConversao,
    // extrato_aposentadoria: showExtratoAposentadoria, // desativado card de extrato
  } = useSelector((state) => state.telasDisponiveis);

  useEffect(() => {
    dispatch(
      recuperaPersonalizacaoRequest({
        matricula: user.matricula,
        plano: user.plano,
      })
    );
  }, []);

  useEffect(() => {
    dispatch(
      recuperaPersonalizacaoRequest({
        matricula: user.matricula,
        plano: user.plano,
      })
    );
  }, [user.plano]);

  return (
    <>
      <h1 className="fw-bold page-title mb-2">
        Personalização da página inicial
      </h1>
      <hr />
      <div className="d-flex col-3 col-md-2 col-lg-1 justify-content-center">
        <Button
          className="justify-content-center mb-32 mt-32"
          transparent
          color="orange"
          icon="arrow_back"
          onClick={() => navigate(-1)}
        >
          Voltar
        </Button>
      </div>
      <div className="card">
        <div className="card-body">
          <Formik
            enableReinitialize
            validateOnChange
            initialValues={personalizaHome}
            onSubmit={(values, { setSubmitting }) => {
              dispatch(
                alterarPersonalizacaoRequest({
                  matricula: user.matricula,
                  plano: user.plano,
                  preferencias: values,
                })
              );
              setSubmitting(false);
              navigate(HOME);
            }}
          >
            {({ handleSubmit, isSubmitting }) => (
              <form onSubmit={handleSubmit}>
                <div className="row mb-5">
                  {showSaldo && (
                    <div className="col-12 col-md-4">
                      <p className="ts-20 mb-3 text-muted fw-bold">Plano</p>
                      {showTabelaContribuicao && (
                        <Field
                          className="mb-3"
                          name="contribuicoes"
                          label="Contribuições"
                          simple
                          component={Toggler}
                        />
                      )}
                      {showAlterarPerfil && (
                        <Field
                          className="mb-3"
                          name="investimentos"
                          label="Investimentos"
                          simple
                          component={Toggler}
                        />
                      )}
                      <Field
                        className="mb-3"
                        name="saldo"
                        label="Saldo"
                        simple
                        component={Toggler}
                      />
                    </div>
                  )}
                  <div className="col-12 col-md-4">
                    <p className="ts-20 mb-3 text-muted fw-bold">Benefícios</p>
                    {(showTransformacaoReserva ||
                      showSaqueVista ||
                      showReservaMatematica ||
                      showAlterarRecebimento ||
                      showParcelaAdicional ||
                      showMemoriaCalculo ||
                      showInforme ||
                      showConversao ||
                      // showContracheque ||
                      showBeneficio) && (
                      <Field
                        className="mb-3"
                        name="simulador"
                        label="Benefícios"
                        simple
                        component={Toggler}
                      />
                    )}
                    {/* {showContracheque && (
                      <Field
                        className="mb-3"
                        name="contracheque"
                        label="Contracheque"
                        simple
                        component={Toggler}
                      />
                    )} */}
                  </div>
                  <div className="col-12 col-md-4">
                    <p className="ts-20 mb-3 text-muted fw-bold">Diversos</p>
                    <Field
                      name="outros"
                      className="mb-3"
                      label="Outros"
                      simple
                      component={Toggler}
                    />
                    <Field
                      className="mb-3"
                      name="transparencia"
                      label="Transparência"
                      simple
                      component={Toggler}
                    />
                    <Field
                      name="faleConosco"
                      className="mb-3"
                      label="Fale conosco"
                      simple
                      component={Toggler}
                    />
                    {/* desativado card de extrato */}
                    {/* showExtratoAposentadoria && (
                      <Field
                        className="mb-3"
                        name="cardExtratoConta"
                        label="Extrato de Conta"
                        simple
                        component={Toggler}
                      />
                    ) */}
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-md-4">
                    <p className="ts-20 mb-3 text-muted fw-bold">Empréstimos</p>
                    <Field
                      className="mb-3"
                      name="simularContratar"
                      label="Empréstimos"
                      simple
                      component={Toggler}
                    />
                  </div>
                </div>
                <div className="card-footer">
                  <hr className="mb-32" />
                  <div className="d-block d-md-flex align-items-center ms-auto col-12 col-md-8 col-lg-6">
                    <Button
                      className="ms-0 ms-lg-3 mt-3 mt-lg-0"
                      type="submit"
                      disabled={isSubmitting}
                    >
                      Atualizar
                    </Button>
                  </div>
                </div>
              </form>
            )}
          </Formik>
        </div>
      </div>
    </>
  );
};
